import React, {useEffect, useState} from 'react';
import {
    IonPage,
    IonContent,
    IonButton,
    IonIcon,
    IonModal,
    IonDatetime,
} from '@ionic/react';
import NewsLetterCard from "../components/NewsLetterCard";
import {calendarOutline} from "ionicons/icons";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "../components/Loader/FacebookLoader";
import NoDataFoundOrSelectedDiv from "../components/NoDataFoundOrSelectedDiv";
import {
    actionToGetMemberPanelNewsLetterByFilter
} from "../apiHelpers/CommonAction";


const years = [];
for (let i = new Date().getFullYear(); i >= 2000; i--) {
    years.push(i);
}

export default function NewsletterMobilePage({handleScroll,renderHeaderPage}) {
    const [isSticky, setIsSticky] = useState(false);
    const [isCustomYearPickerOpen, setIsCustomYearPickerOpen] = useState(false);
    const [lastScrollTop, setLastScrollTop] = useState(0);
    const [tempYear, setTempYear] = useState(new Date().getFullYear());
    const { newsLettersDataState,selectedNewsLetterDateFilter,setSelectedNewsLetterDateFilter } = useStore();
    const { newsLettersData, loading,totalCount } = newsLettersDataState;
    const isFetchingRef = React.useRef(false); // prevent multiple calls
    const observerRef = React.useRef(null);

    const callFunctionToHandleScroll = (event) => {
        handleScroll(event);
        const scrollTop = event.detail.scrollTop;

        if (scrollTop < lastScrollTop ) {
            // Scrolling UP → stick
            setIsSticky(false);
        } else {
            // Scrolling DOWN → unstick
            setIsSticky(true);
        }

        setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop);
    };


    const callFunctionToFilterNewsLetterData = async (isLoad = true,isPastEvent)=>{
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;
        const payload = {};
        if (isPastEvent) payload.news_year = isPastEvent;
        await actionToGetMemberPanelNewsLetterByFilter(isLoad,payload);
        isFetchingRef.current = false;
    }

    const lastEventsElementRef = React.useCallback(
        (node) => {
            if (observerRef.current) observerRef.current.disconnect();

            observerRef.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && newsLettersData?.length < totalCount) {
                    callFunctionToFilterNewsLetterData(false,selectedNewsLetterDateFilter); // Load next page
                }
            });

            if (node) observerRef.current.observe(node);
        },
        [callFunctionToFilterNewsLetterData,newsLettersData,totalCount]
    );



    useEffect(() => {
        callFunctionToFilterNewsLetterData(true,new Date().getFullYear());
    },[])


    const handleYearChange = () => {
        setSelectedNewsLetterDateFilter(tempYear);
        setIsCustomYearPickerOpen(false);
        callFunctionToFilterNewsLetterData(true,tempYear);
    };
    const selectCustomYearChange = (year) => {
        setSelectedNewsLetterDateFilter(year);
        setTempYear(year);
        setIsCustomYearPickerOpen(false);
        callFunctionToFilterNewsLetterData(true,year);
    };


    const panelSubHeader = ()=>{
        return (
            <div className={`filter-header-wrapper`}>
                <div className="filter-header in_news_feeds">
                    <IonButton fill="clear" size="small" onClick={() => setIsCustomYearPickerOpen(true)} className="filter-btn">
                        <IonIcon icon={calendarOutline} slot="start"/>
                    </IonButton>
                    <div className="tags">
                        {(years?.map((year)=> (
                            <span key={year} className={`tag ${selectedNewsLetterDateFilter === year ? 'active' : ''}`}
                                  onClick={() => selectCustomYearChange(year)}>{year}</span>
                        )))}
                    </div>
                </div>
            </div>
        )
    }


    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage(panelSubHeader)}
            <IonContent fullscreen scrollEvents={true} onIonScroll={callFunctionToHandleScroll}
                        className="feed-content page-content">
                {(loading) ?
                    <div className="job-list">
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                    </div>
                    :
                    (newsLettersData && newsLettersData?.length > 0) ?
                        <div className="news-letter-in-mobile-list">
                            {newsLettersData.map((event, index) => {
                                if (index === newsLettersData.length - 1) {
                                    return (
                                        <div ref={lastEventsElementRef} key={event.id}>
                                            <NewsLetterCard post={event}/>
                                        </div>
                                    );
                                }
                                return (
                                    <NewsLetterCard key={event.id} post={event}/>
                                );
                            })}
                        </div>
                        :
                        <div className="job-list">
                            <NoDataFoundOrSelectedDiv/>
                        </div>
                }
            </IonContent>
            {/* ✅ Bottom Year Picker Slider */}
            <IonModal breakpoints={[0,0.3]} initialBreakpoint={0.3} isOpen={isCustomYearPickerOpen} onDidDismiss={handleYearChange}>
                <IonDatetime
                    presentation="year"
                    className={"bottom_date_picker"}
                    min={2000}
                    onIonChange={(e) => {
                        const year = new Date(e.detail.value).getFullYear();
                        setTempYear(year);
                    }}
                    value={tempYear.toString()}
                />
            </IonModal>
        </IonPage>
    );
}
